/**
 * The automatic person search of a tracker list (PREC-4399): when a P1-P3 signal arrives for a
 * company where the tracker knows nobody, and the list's Find person switch is on, one person is
 * searched for with the list's search profiles. Its state is kept on the tracker company, and the
 * company's lead row shows it.
 */
export enum TrackerFindPersonStatus {
	SEARCHING = "SEARCHING",
	FOUND = "FOUND",
	NOT_FOUND = "NOT_FOUND",
	/** A signal could have started a search, but the balance could not pay for one. */
	NO_CREDITS = "NO_CREDITS",
}

/**
 * Days after which a search that found nobody may run again, on the company's next P1-P3 signal.
 * It also runs again sooner when the list's search profiles change. Never from a timer.
 */
export const TRACKER_FIND_PERSON_RETRY_DAYS = 90;

/**
 * Hours after which a search still marked as running is taken for dead: a new signal may start
 * another, and the company's row stops saying "Searching". A search takes minutes.
 */
export const TRACKER_FIND_PERSON_STALE_SEARCH_HOURS = 6;
